<template>
    <Dropdown trigger="click" @on-click="changeLang" class="pop" placement="bottom-end">
        <a href="javascript:void(0)">
            <template v-for=" curlang in lang.type">
                {{local == curlang.val ? curlang.title : null }}
            </template>
            <Icon type="ios-arrow-down"></Icon>
        </a>
        <DropdownMenu slot="list">
            <template v-for=" curlang in lang.type">
                <DropdownItem :name="curlang.val">{{curlang.title}}</DropdownItem>
            </template>
        </DropdownMenu>
    </Dropdown>
</template>
<script>
    import {mapState} from "vuex"
    import {Dropdown,DropdownMenu,DropdownItem,Icon} from 'iview'
    export default {
        components:{
            Dropdown,DropdownMenu,DropdownItem,Icon
        },
        data(){
          return{
              
          }
        },
        computed:
          mapState(['lang','local'])
        ,
        mounted(){
            
        },
        methods:{
            changeLang(lang){  
                this.$store.commit('changeLang', lang)
            },
            
        }
    }
</script>

<style lang="less" scoped>
.pop{    
    margin-left:10px;
    position: relative;
    top:-3px;    
    a{
        color:#aaa;
    }
}
    
</style>


